export const ERROR_MESSAGES = {
    FIELD_CANNOT_BE_EMAIL: 'Field company name cannot be e-mail',
    FIELD_CANNOT_BE_URL: 'Field company name cannot be url',
    FIELD_CANNOT_BE_NUMBER_AND_SPECIAL_CHARS: 'Field company name cannot be only numbers or special characters.',
    USER_PROFILE_ALREADY_EXISTS: 'User profile already exists',
    UNKNOWN_ERROR: 'Unknown error',
};
